import axios from 'axios';

/**
 * 日付をフォーマットする
 * @param  {Date}   date     日付
 * @param  {String} [format] フォーマット
 * @return {String}          フォーマット済み日付
 */
export function formatDate(date, format) {
  if (!format) format = 'YYYY-MM-DD hh:mm:ss.SSS';
  format = format.replace(/YYYY/g, date.getFullYear());
  format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
  format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
  format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
  format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
  format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
  if (format.match(/S/g)) {
    let milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
    let length = format.match(/S/g).length;
    for (let i = 0; i < length; i++) {
      format = format.replace(/S/, milliSeconds.substring(i, i + 1));
    }
  }
  return format;
}

/**
 * 文字列のtrue or false をboolean型に変換する
 * @param  {booleanStr}   true or false     文字列
*/
export function toBoolean(booleanStr) {
  return booleanStr.toLowerCase() === 'true';
}

/**
 * 文字列を指定した文字列で全置換する
 * @param  {str}   置換したい文字列     文字列
 * @param  {booleanStr}   置換対象文字列     文字列
 * @param  {booleanStr}   置換後文字列     文字列
*/
export function replaceAll(str, before, after) {
  return str.split(before).join(after);
}

/**
 * Htmlタグを除去
 * @param {string} str Htmlタグが含まれた文字列(<h1>サンプル文字列</h1>)
 * @returns {string} Htmlタグ除去された文字列(サンプル文字列)
*/
export function removeHtmlTag(str) {
  return String(str).replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
};

/**
 * 全角英数を半角英数にする
 * @param {string} str 全角英数(ａｂｃ１２３)
 * @returns {string} 半角英数(abc123)
*/
const convertHalfWidthToFullWidth = function (str) {
  return String(str).replace(/[Ａ-Ｚａ-ｚ０-９]/g, e => {
    return String.fromCharCode(e.charCodeAt(0) - 0xFEE0);
  });
};

/**
 * 数値文字列にカンマ区切りにする
 * @param  {string} numberString 数値文字列。
 * @returns {string} カンマ区切りの数値文字列
*/
const insertCommaDelimiter = function (numberString) {
  return String(numberString).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

/**
 * カンマ区切りの数値文字列を数値にする
 * @param  {string} numberString 数値文字列。
 * @returns {number} カンマを取り除いた数値
*/
const removeCommaDelimiter = function (numberString) {
  return Number(numberString.replace(/,/g, ''));
};

/**
 * ブラウザの横幅取得
 * @returns {number} ブラウザの横幅
*/
export function getBrowserWidth() {
  let width = 0;
  if (window.innerWidth) {
    width = window.innerWidth;
  } else if (document.documentElement && document.documentElement.clientWidth !== 0) {
    width = document.documentElement.clientWidth
  } else if (document.body && document.body.clientWidth !== 0) {
    width = document.body.clientWidth;
  }
  return width
};

/**
 * ブラウザの高さ取得
 * @returns {number}  ブラウザの高さ
*/
const getBrowserHeight = function () {
  let height = 0;
  if (window.innerHeight) {
    height = window.innerHeight;
  } else if (document.documentElement && document.documentElement.clientHeight !== 0) {
    height = document.documentElement.clientHeight;
  } else if (document.body && document.body.clientHeight !== 0) {
    height = document.body.clientHeight;
  }
  return height;
};

/**
 * ウェブページ自体の横幅
 * @returns {number} ウェブページ自体の横幅
*/
const getContentsWidth = function () {
  const calc_array = [
    document.body.clientWidth,
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.documentElement.clientWidth
  ];
  const max_width = Math.max.apply(null, calc_array);
  return max_width ? max_width : 0
};

/**
 * ウェブページ自体の高さ取得
 * @returns {number} ウェブページ自体の高さ
*/
const getContentsHeight = function () {
  const calc_array = [
    document.body.clientHeight,
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.documentElement.clientHeight
  ];
  const max_height = Math.max.apply(null, calc_array);
  return max_height ? max_height : 0
};

/**
 * ブラウザの高さとウェブページの高さから現在の位置を計算する
 * @returns {{}}
*/
const calculatePosition = function () {
  /**
   * ブラウザの高さ(px)
   * @type {number}
  */
  const browser_height = getBrowserHeight();
  /**
   * Webページの高さ(px)
   * @type {number}
  */
  const contents_height = getContentsHeight();
  /*
   * 下記のページ数処理がを行う際にブラウザの高さとコンテンツの高さが
   * 取得できないとページ数計算が進まないので
   * 取得できない場合はは処理しない
  */
  if (!contents_height && !browser_height) {
    return false
  }
  /**
   * スクロールの上からの移動位置(px)
   * @type {number}
  */
  const scroll_top_value = window.pageYOffset ? window.pageYOffset : 0;
  /**
   * コンテンツの高さをブラウザの高さで割って、何ページあるか計算
   * @type {number}
  */
  const total_page_number = Math.floor(contents_height / browser_height);
  /**
   * 1ページの高さ計算
   * @type {number}
  */
  const page_height = contents_height / total_page_number;
  /**
   * 現在のスクロール位置がのコンテンツの何ページ目か取得
   * @type {number}
  */
  const page_number = function (t, s, p) {
    // スクロール位置が特定のページの範囲にあればループからでる
    for (let i = 1; i <= t; i++) {
      const min_page_height = p * (i - 1);
      const max_page_height = p * i;
      if (min_page_height < s && s < max_page_height || s === 0) {
        return i;
      }
    }
    return 0;
  }(total_page_number, scroll_top_value, page_height);
  return {
    browser_height: browser_height,
    contents_height: contents_height,
    scroll_top_value: scroll_top_value,
    total_page_number: total_page_number,
    page_number: page_number
  }
};

/**
 * json取得のURL生成
*/
export function setJsonUrl(url, parms) {
  let cnt = 0
  for (let key in parms) {
    if (cnt == 0) {
      url += '?' + key + '=' + parms[key]
    } else {
      url += '&' + key + '=' + parms[key]
    }
    cnt++;
  }
  return url;
}

/**
 * URLパラメーターをオブジェクトで返す
*/
export function getQueryObj() {
  let obj = {},
    query = location.search.substring(1),
    parameters = query.split('&');
  for (var i = 0; i < parameters.length; i++) {
    let elm = parameters[i].split('='),
      name = decodeURIComponent(elm[0]),
      value = decodeURIComponent(elm[1])
    obj[name] = decodeURIComponent(value);
  }
  return obj;

}